import { createFileRoute, Link } from "@tanstack/react-router";
import { LoanCategoryPage } from "@/components/laneguide/LoanCategoryPage";

export const Route = createFileRoute("/lan-utan-uc")({
  head: () => ({
    meta: [
      { title: "Lån utan UC – Jämför långivare utan UC-upplysning | Svensk Låneguide" },
      { name: "description", content: "Jämför lån utan UC. Långivare som använder andra kreditbyråer – din UC-poäng påverkas inte." },
      { property: "og:title", content: "Lån utan UC – Jämför alternativa långivare" },
      { property: "og:description", content: "Jämför lån utan UC hos alternativa kreditgivare." },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => (
    <LoanCategoryPage
      page="lan-utan-uc"
      productLabel="Lån utan UC"
      headingBefore="Låna pengar utan UC –"
      underlined="Anmärkningar godkänns"
      headingAfter=""
      subtitle={
        <>
          Ett <Link to="/nyhet/$slug" params={{ slug: "snabblan-utan-uc" }} className="text-primary underline underline-offset-2">lån utan UC</Link> innebär att långivaren inte hämtar in en kreditupplysning från UC AB – ansökan syns därför inte i UC:s register. Långivarna gör istället en egen bedömning via Creditsafe, Bisnode eller D&B, vilket gör att fler blir beviljade även med låg kreditvärdighet, betalningsanmärkningar, utan fast inkomst eller som arbetslös. Här hittar du bästa lånet utan UC för din situation och lär dig när det passar att använda.
        </>
      }
      lockedFilter="utan-uc"
      featuredTitleTemplate={(m) => `Toppval för lån utan UC i ${m}`}
    />
  ),
});
